/*
 * @Author: duchongchong1
 * @Date: 2022-11-06 20:13:14
 * @LastEditors: duchongchong1
 * @LastEditTime: 2023-08-28 11:19:28
 * @FilePath: /isp_International/src/api/newApi/search.ts
 * @Description:
 */
/* eslint-disable no-undef */
// import { RootObject } from "config";
import http from '../axios';
import {
  ApiResponse,
  buildRequestCacheKey,
  readTtlCache,
  RequestParams,
  withInflightDedupe,
  writeTtlCache,
} from '@/util/requestDedupe';

const ATTEMPT_CACHE_TTL = 30 * 1000;
const searchRequestInflight = new Map<string, Promise<ApiResponse>>();
const attemptInflight = new Map<string, Promise<ApiResponse>>();
const attemptCache = new Map<string, { expiresAt: number; value: ApiResponse }>();

const isSuccessResponse = (res: unknown): res is ApiResponse =>
  Boolean(res && typeof res === 'object' && (res as { success?: unknown }).success === true);

const requestSearchApi = (method: 'get' | 'jsonpost', url: string, params: RequestParams): Promise<ApiResponse> =>
  new Promise((resolve, reject) => {
    http(method, url, params, false, true).then(
      res => {
        resolve(res as ApiResponse);
      },
      error => {
        console.log('网络异常~', error);
        reject(error);
      },
    );
  });

const requestSearchWithDedupe = (method: 'get' | 'jsonpost', url: string, params: RequestParams): Promise<ApiResponse> => {
  const cacheKey = `${method}:${buildRequestCacheKey(url, params)}`;
  // 搜索页路由、筛选和分页可能在短时间内触发相同请求；合并同参数并发，不缓存结果避免旧数据影响筛选。
  return withInflightDedupe(searchRequestInflight, cacheKey, () => requestSearchApi(method, url, params));
};

/**
 * 搜索
 */
export function goSearch(params: any = {}) {
  return new Promise((resolve, reject) => {
    http('get', '/jdig/search/search', params, false, true).then(
      res => {
        resolve(res);
      },
      error => {
        console.log('网络异常~', error);
        reject(error);
      },
    );
  });
}

/**
 * 
添加搜索历史
https://ce-iep.jd.com/jdig/search/addSearchHistory
 */
export function addSearchHistory(word: string) {
  return new Promise((resolve, reject) => {
    http('get', '/jdig/search/addSearchHistory', { word }, false, true).then(
      res => {
        resolve(res);
      },
      error => {
        console.log('网络异常~', error);
        reject(error);
      },
    );
  });
}

export function getSearchHistoryList() {
  return http('get', '/jdig/search/searchHistory', {}, false, true);
}

/**
 * 删除搜索历史
 */
export function delHistory(params: any = {}) {
  return new Promise((resolve, reject) => {
    http('get', '/jdig/search/delHistory', params, false, true).then(
      res => {
        resolve(res);
      },
      error => {
        console.log('网络异常~', error);
        reject(error);
      },
    );
  });
}
/**
 * 获取商卡参数
 */
export function getBusinessCardInfo(params: any = {}) {
  return new Promise((resolve, reject) => {
    http('get', '/jdig/search/getBusinessCardInfo', params, false, true).then(
      res => {
        resolve(res);
      },
      error => {
        console.log('网络异常~', error);
        reject(error);
      },
    );
  });
}

// 搜索--搜列
export function getSearchList(params: RequestParams) {
  return requestSearchWithDedupe('jsonpost', '/jdig/search/search', params);
}

// 搜索--搜列商品
export function getSearchGoodList(params: RequestParams) {
  return requestSearchWithDedupe('jsonpost', '/jdig/product/searchWares', params);
}
// 搜索--搜列筛选项
export function getSearchCombined(params: RequestParams) {
  return requestSearchWithDedupe('jsonpost', '/jdig/search/searchCombined', params);
}
// 落地页---精选类目
export function getMarketDetail(params: any) {
  return new Promise((resolve, reject) => {
    http('jsonpost', '/jdig/market/detail', params, false, true).then(
      res => {
        resolve(res);
      },
      error => {
        console.log('网络异常~', error);
        reject(error);
      },
    );
  });
}
// 搜索--获取搜列面包屑类目
// export function getCateInfo(params: any) {
//   return new Promise((resolve, reject) => {
//     http('jsonpost', '/jdig/category/getCateInfo', params, false, true).then(
//       res => {
//         resolve(res);
//       },
//       error => {
//         console.log('网络异常~', error);
//         reject(error);
//       },
//     );
//   });
// }

//获取下一级类目
export function getNextCategory(params: any) {
  return new Promise((resolve, reject) => {
    http('get', '/jdig/category/nextCategory', params, false, true).then(
      res => {
        resolve(res);
      },
      error => {
        console.log('网络异常~', error);
        reject(error);
      },
    );
  });
}

//获取类目名称
export function getCategoryName(params: any) {
  return new Promise((resolve, reject) => {
    http('get', '/jdig/category/categoryName', params, false, true).then(
      res => {
        resolve(res);
      },
      error => {
        console.log('网络异常~', error);
        reject(error);
      },
    );
  });
}
// 搜索-加入购物车
export function addProducts(params: any) {
  return new Promise((resolve, reject) => {
    http('jsonpost', '/jdig/cart/addProducts', params, false, true).then(
      res => {
        resolve(res);
      },
      error => {
        console.log('网络异常~', error);
        reject(error);
      },
    );
  });
}
/**
 * 获取联想词
 */
// /jdig/search/attempt
export function getAcquireAssociativeWords(key: string) {
  const params = { key: key.trim() };
  const cacheKey = buildRequestCacheKey('/jdig/search/attempt', params);
  const cached = readTtlCache(attemptCache, cacheKey);
  if (cached) {
    return Promise.resolve(cached);
  }

  // 联想词是输入框高频接口：同词并发合并，短期缓存成功结果，避免删除/回输入时重复打后端。
  return withInflightDedupe(attemptInflight, cacheKey, () =>
    requestSearchApi('get', '/jdig/search/attempt', params).then(res => {
      if (isSuccessResponse(res)) {
        writeTtlCache(attemptCache, cacheKey, res, ATTEMPT_CACHE_TTL);
      }
      return res;
    }),
  );
}

/**
 * 搜索热词和暗纹
 * @returns
 */
// export function getSearchHotAndDark() {
//   return http('get', '/jdig/search/hotAndDark', {}, false, true);
// }

/**
 * 判断搜索条件是不是sku
 * @param sku 商品编码
 */
export function isSkuId(sku: string) {
  return http('get', '/jdig/product/isSkuSearch', { sku }, false, true);
}


// 搜索-获取mku列表库存数量
export function getRemainStockList(params: any) {
  return new Promise((resolve, reject) => {
    http('jsonpost', '/jdig/stock/remain/list', params, false, true).then(
      res => {
        resolve(res);
      },
      error => {
        console.log('网络异常~', error);
        reject(error);
      },
    );
  });
}
